import { TBEGenricResponse, TGenericDatasetQueryParams } from 'api/types';

export enum TOrderStatusEnum {
  Created = 'Created',
  Payed = 'Payed',
  InProgress = 'InProgress',
  InDelivery = 'inDelivery',
  Done = 'Done',
  Refunded = 'Refunded',
}

export type TOrderItemStock = {
  name: string;
  variation: string;
};

export enum TOrderCheckoutItemProductType {
  PhoneCase = 'PhoneCase',
}

export type TOrderCheckoutItem = {
  price: number;
  productId: string;
  productType: TOrderCheckoutItemProductType;
  productImage: string;
  productName: string;
  quantity: number;
  stock: TOrderItemStock[];
};

export type TOrderShippingData = {
  phone: string;
  city: string;
  postalCode: string;
  street: string;
  buildingNumber: string;
  apartamentNumber: string;
  firstName: string;
  lastName: string;
  deliveryMethod: string;
  parcelLockerCode: string;
  email: string;
  additionalInfo: string | null;
};

export type TOrderItem = {
  id: string;
  checkoutItems: TOrderCheckoutItem[];
  reservationId: string;
  totalPrice: number;
  orderNumber: string;
  status: TOrderStatusEnum;
  payed: boolean;
  receiveNotifications: boolean;
  policyAccepted: boolean;
  payment: Record<string, unknown> | null;
  shippingData: TOrderShippingData;
  userId: string | null;
  createdAt: string;
  updatedAt: string;
};

export type TOrdersGetListQueryParams = TGenericDatasetQueryParams;

export type TOrdersGetListBE = TBEGenricResponse<{
  items: TOrderItem[];
  pagination?: {
    page: number;
    perPage: number;
    total: number;
    prevPagination?: TOrdersGetListQueryParams;
  };
}>;
